import TasksPerformedIcon from './component'

export default TasksPerformedIcon
